
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[exchange]/[ticker]/dividend",
      function () {
        return require("private-next-pages/s/[exchange]/[ticker]/dividend/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[exchange]/[ticker]/dividend"])
      });
    }
  